var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBadgeAi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 51,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 51,
  height: 24,
  fill: "#FF3000",
  fillOpacity: 0.1,
  rx: 12
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#badge-ai_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#badge-ai_svg__b)",
  d: "m15 6 1.237 2.263L18.5 9.5l-2.263 1.237L15 13l-1.237-2.263L11.5 9.5l2.263-1.237z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#badge-ai_svg__c)",
  d: "m20 11 .884 1.616 1.616.884-1.616.884L20 16l-.884-1.616L17.5 13.5l1.616-.884z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#badge-ai_svg__d)",
  d: "m15 15 .53.97.97.53-.97.53L15 18l-.53-.97-.97-.53.97-.53z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#badge-ai_svg__e)",
  d: "m34.934 16-.715-2.162h-3.112L30.381 16h-1.53l3-8.455h1.7L36.557 16zm-2.315-6.844-1.16 3.487h2.408L32.72 9.156zM39.522 16H38.01V7.545h1.512z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "badge-ai_svg__b",
  x1: 11.818,
  x2: 16.493,
  y1: 8.042,
  y2: 12.823,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "badge-ai_svg__c",
  x1: 17.727,
  x2: 21.067,
  y1: 12.458,
  y2: 15.874,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "badge-ai_svg__d",
  x1: 13.636,
  x2: 15.64,
  y1: 15.875,
  y2: 17.924,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "badge-ai_svg__e",
  x1: 28.591,
  x2: 39.099,
  y1: 8.667,
  y2: 17.399,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "badge-ai_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 6h12v12H11z"
})))));
export { SvgBadgeAi as ReactComponent };
export default __webpack_public_path__ + "static/media/badge-ai.7df4b577.svg";